<template>
  <div
    class="flex w-full justify-between items-center px-4 py-3 border-t-1 border-b-1 cursor-pointer"
    :class="isActive ? 'border-primary' : 'border-grey'"
  >
    <indicator-module indicatorClass="w-2 h-2 flex-shrink-0" :class="isActive ? 'bg-green' : 'bg-grey'" />
    <div class="flex items-center">
      <div class="mr-4">
        <p class="text-4xs" :class="isActive ? 'text-primary' : 'text-grey-chart'">
          {{ isActive ? $t('Current User') : $t('Switch to') }}
        </p>
        <p>{{ investor?.account_type == 'company' ? investor.company_name : investor.full_name }}</p>
        <p class="text-4xs" :class="isActive ? 'text-primary' : 'text-grey-chart'">{{ investor.company.name }}</p>
      </div>
      <span class="icon-user_icon text-base" :class="isActive ? 'text-primary' : 'text-grey'"></span>
    </div>
  </div>
</template>

<script>
import IndicatorModule from '@/components/shared/IndicatorModule'

export default {
  props: ['investor', 'isActive'],

  components: {
    IndicatorModule
  }
}
</script>
